import { Checkbox, Col3Col9, ModalPopup } from '@aon/aon-tws-common-ui';
import React, { useState } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';
import { IApplicationState } from '../../store';
import { ActionCreators as AudienceListActionCreators } from '../../store/AudienceListStore';
import { DistributionHelper } from '../../utilities/DistributionHelper';
import { AudienceMode } from './AudienceMode';

const CheckboxContainer = styled.div`
	margin-top: 30px;
`;
CheckboxContainer.displayName = 'CheckboxContainer';

export const AudienceCopyModal = (props: { mode: AudienceMode }) => {
	const dispatch = useDispatch();
	const { pendingCopyAudience, copyModalOpen } = useSelector((state: IApplicationState) => state.audienceList);

	const [isTestAudience, setIsTestAudience] = useState(false);

	const usesDistributionList = DistributionHelper.usesDistributionList(pendingCopyAudience?.distributionType);

	const headline = usesDistributionList
		? ContentConstants.COPY_AUDIENCE_MODAL_DISTRIBUTION_HEADLINE
		: ContentConstants.COPY_AUDIENCE_MODAL_NO_DISTRIBUTION_HEADLINE;

	const modalContentBody = usesDistributionList
		? ContentConstants.COPY_AUDIENCE_MODAL_DISTRIBUTION_BODY
		: ContentConstants.COPY_AUDIENCE_MODAL_NO_DISTRIBUTION_BODY;

	const submitButton = usesDistributionList ? ContentConstants.BUTTONS_UPDATE : ContentConstants.BUTTONS_COPY;

	return (
		<ModalPopup
			isOpen={copyModalOpen}
			title={ContentConstants.COPY_AUDIENCE_MODAL_TITLE}
			primaryButtonText={submitButton}
			secondaryButtonText={ContentConstants.BUTTONS_CANCEL}
			contenthcentered={true}
			contentvcentered={true}
			contentfullwidth={false}
			onClosed={() => dispatch(AudienceListActionCreators.ToggleCopyAudienceModal(false))}
			onSubmit={() => dispatch(AudienceListActionCreators.CopyAudience(pendingCopyAudience!, isTestAudience, props.mode))}
			type={'lightbox'}
		>
			<Col3Col9 label={headline}>
				{modalContentBody}
				<CheckboxContainer>
					<Checkbox
						checked={isTestAudience}
						label={ContentConstants.COPY_AUDIENCE_MODAL_CHECKBOX_LABEL}
						onChange={() => setIsTestAudience(!isTestAudience)}
					/>
				</CheckboxContainer>
			</Col3Col9>
		</ModalPopup>
	);
};
